<template>
    <Head title="Create New Comparison" />
    <BreezeAuthenticatedLayout>
        <template #header>
            <h2 class="font-semibold text-xl text-gray-800 leading-tight">
                Create New Comparison
            </h2>
        </template>
        <BreadCrumbs :items="navItems"></BreadCrumbs>
        <div class="w-full my-6 overflow-hidden py-12 shadow">
            <div class="px-6 pt-4 pb-2">
                <form @submit.prevent="create.post(requestUrl, { preserveScroll: true})" class="w-full">
                    <div class="mb-6 md:mb-4">
                        <admin-app-label>Name</admin-app-label>
                        <input-basic
                            placeholder="Name"
                            v-model="create.name"
                            :error="errors['name']"
                        />
                        <input-error v-if="errors['name']">
                            {{ errors.name }}
                        </input-error>
                    </div>
                    <div class="mb-6 md:mb-4">
                        <admin-app-label>Description</admin-app-label>
                        <input-wysiwyg
                            v-model="create.description"
                        ></input-wysiwyg>
                        <input-error v-if="errors['description']">
                            {{ errors.description }}
                        </input-error>
                    </div>
                    <div class="mb-6 md:mb-4">
                        <admin-app-label>Products</admin-app-label>
                        <input-select
                            multiple
                            searchable
                            placeholder="Products"
                            labelKey="Product"
                            v-model="create.products"
                            :options="products"
                            :error="errors['products']"
                            :get-option-label="getLabel"
                            label="name"
                            :reduce="product => product.id"
                        >
                        </input-select>
                    </div>
                    <seo-tags v-model="create.seo_tags" :errors="errors"></seo-tags>
                    <app-button type="submit" class="mt-8">Create</app-button>
                </form>
            </div>
        </div>
    </BreezeAuthenticatedLayout>
</template>
<script>
import { useForm } from '@inertiajs/inertia-vue3';
import BreadCrumbs from "@/Components/Admin/BreadCrumbs";
import AdminAppLabel from "@/Components/Admin/Forms/AdminAppLabel";
import AppButton from "@/Components/AppButton";
import InputBasic from "@/Components/Admin/Forms/Inputs/InputBasic";
import InputWysiwyg from "@/Components/Admin/Forms/Inputs/InputWysiwyg";
import Label from "@/Components/Label";
import BreezeAuthenticatedLayout from "@/Layouts/Admin/Authenticated";
import {Head} from "@inertiajs/inertia-vue3";
import InputError from "@/Components/Forms/Inputs/InputError";
import InputSelect from "@/Components/Admin/Forms/Inputs/InputSelect";
import SeoTags from "@/Components/Admin/Forms/SeoTags";

export default {
    components: {
        SeoTags,
        InputSelect,
        BreadCrumbs,
        AdminAppLabel,
        AppButton,
        InputBasic,
        InputWysiwyg,
        Label,
        BreezeAuthenticatedLayout,
        Head,
        InputError,
    },
    props: {
        name: String,
        description: String,
        products: Array,
        errors: Object,
        requestUrl: {
            type: String,
            default: '/admin/comparisons'
        }
    },
    data() {
        return {
            navItems: [
                { title: 'Comparisons', path: '/admin/comparisons'},
                { title: 'Create New', path: '/admin/comparisons/create'}
            ],
            create: useForm(
                {
                    name: "",
                    description: "",
                    products: null,
                    seo_tags: null
                }
            )
        }
    },
    methods: {
        getLabel: function(val)
        {
            if(typeof  val === 'object')
            {
                return val.name + ' | ' + val.identifier + ' | ' + this.capitaliseFirst(val.type)
            }
        },
        capitaliseFirst(str)
        {
            if (!str) return;
            return str.match("^[a-z]") ? str.charAt(0).toUpperCase() + str.substring(1) : str;
        }
    }
}
</script>
